module.exports = __webpack_public_path__ + "img/1513927641.5581aa4e.jpg";